/**
 * Which face of the business card to show.
 *
 * The card exists in three lights — golden (sunrise and sunset), day, and
 * night — and the app wears whichever one matches the hour in Vieques. It is
 * decoration with one useful property: Dillon opens the app before dawn and
 * again at closing, and the header quietly confirms the app knows what time it
 * is where he is.
 *
 * The business timezone, never the device's. A phone still set to Michigan
 * would otherwise show him a moon over a bright Caribbean morning.
 */
export type Light = 'golden' | 'day' | 'night'

export function lightAt(now: Date = new Date(), timeZone = 'America/Puerto_Rico'): Light {
  let hour: number
  try {
    hour = Number(new Intl.DateTimeFormat('en-US', {
      timeZone, hour: 'numeric', hour12: false,
    }).format(now))
  } catch {
    // An environment without full ICU data is not a reason to render nothing.
    hour = now.getHours()
  }
  // Vieques sits far enough east in its zone that first light is early and the
  // sun is down by about seven for most of the year. Two golden bands, one at
  // each end, and everything between them is simply day or night.
  if (hour >= 5 && hour < 8) return 'golden'
  if (hour >= 8 && hour < 17) return 'day'
  if (hour >= 17 && hour < 20) return 'golden'
  return 'night'
}

export const sceneFor = (light: Light) => `/brand/scene-${light}.webp`
export const cardFor = (light: Light) => `/brand/card-${light}.webp`
